module.exports = __webpack_public_path__ + "img/006.7810a2b8.svg";